// payment error codes

module.exports = {
  '1': 'La transaction n\'a pas été trouvée.',
  '2': 'La transaction n\'a pas été trouvée.',
  '3': 'Cette action n\'est pas autorisée sur une transaction ayant ce statut {0}.',
  '4': 'Cette transaction n\'est pas autorisée dans ce contexte.',
  '5': 'La transaction existe déjà.',
  '6': 'Montant de transaction invalide.',
  '7': 'Cette action n\'est plus possible pour une transaction créée à cette date.',
  '8': 'La date d\'expiration de la carte ne permet pas cette action.',
  '9': 'CVV obligatoire pour la carte.',
  '10': 'Le montant de remboursement est supérieur au montant initial.',
  '11': 'La somme des remboursements effectués est supérieure au montant initial.',
  '12': 'La duplication d\'un crédit (remboursement) n\'est pas autorisée.',
  '13': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '14': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '15': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '16': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '17': 'Le téléparamétrage du contrat Aurore a échoué.',
  '18': 'L\'analyse de la réponse Cetelem a échoué.',
  '19': 'Devise inconnue.',
  '20': 'Type de carte invalide.',
  '21': 'Aucun contrat trouvé pour ce paiement. Veuillez modifier les données ou contacter votre gestionnaire en cas d\'échecs répétés.',
  '22': 'Boutique non trouvée.',
  '23': 'Contrat ambigüe',
  '24': 'Contrat invalide',
  '25': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '26': 'Numéro de carte invalide',
  '27': 'Numéro de carte invalide',
  '28': 'Numéro de carte invalide',
  '29': 'Numéro de carte invalide',
  '30': 'Numéro de carte invalide (Luhn)',
  '31': 'Numéro de carte invalide (longueur)',
  '32': 'Numéro de carte invalide (non trouvé)',
  '33': 'Numéro de carte invalide (non trouvé)',
  '34': 'Contrôle carte à autorisation systématique en échec.',
  '35': 'Contrôle e-Carte Bleue en échec.',
  '36': 'Le contrôle des risques a provoqué le refus de la transaction.',
  '37': 'Interruption non gérée lors du processus de paiement.',
  '38': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '39': 'Refus 3D Secure pour la transaction.',
  '40': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '41': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '42': 'Une erreur interne est survenue lors de la consultation du numéro de carte.',
  '43': 'Une erreur interne est survenue lors de la consultation du numéro de carte.',
  '44': 'Il n\'est pas possible de forcer une autorisation à 1 euro.',
  '45': 'Devise invalide pour la modification.',
  '46': 'Le montant est supérieur au montant autorisé.',
  '47': 'La date de présentation souhaitée est postérieure à la date de validité de l\'autorisation.',
  '48': 'La modification requise est invalide.',
  '49': 'Définition du paiement multiple invalide.',
  '50': 'Boutique inconnue.',
  '51': 'Cours inconnu.',
  '52': 'Le contrat est clos depuis le {0}.',
  '53': 'La boutique {0} est close depuis le {1}.',
  '54': 'Paramètre rejeté pouvant contenir des données sensibles {0}.',
  '55': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '57': 'Erreur lors de la récupération de l\'alias.',
  '58': 'Le statut de l\'alias n\'est pas compatible avec cette opération',
  '59': 'Erreur lors de la récupération de l\'alias.',
  '60': 'Alias existant.',
  '61': 'Alias invalide',
  '62': 'Création d\'un alias refusée.',
  '63': 'Abonnement déjà existant.',
  '64': 'Cet abonnement est déjà résilié.',
  '65': 'Cet abonnement est invalide.',
  '66': 'La règle de récurrence n\'est pas valide.',
  '67': 'Création de l\'abonnement refusée.',
  '69': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '70': 'Code pays invalide.',
  '71': 'Paramètre du service web invalide.',
  '72': 'Refus d\'autorisation par Cofinoga.',
  '73': 'Refus de l\'autorisation à 1 euro.',
  '74': 'Configuration de paiement invalide.',
  '75': 'L\'opération a été refusée par PayPal.',
  '76': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '77': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '78': 'Identifiant de transaction non défini.',
  '79': 'Identifiant de transaction déjà utilisé.',
  '80': 'Identifiant de transaction expiré.',
  '81': 'Contenu du thème config invalide.',
  '82': 'Le remboursement n\'est pas autorisé.',
  '83': 'Montant de transaction en dehors des valeurs permises.',
  '84': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '85': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '86': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '87': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '88': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '89': 'La modification n\'est pas autorisée.',
  '90': 'Une erreur est apparue lors du remboursement de cette transaction.',
  '91': 'Aucune option de paiement activée pour ce contrat.',
  '92': 'Une erreur est survenue lors du calcul du canal de paiement.',
  '93': 'Une erreur est survenue lors du retour de l\'acheteur sur la page de finalisation de paiement.',
  '94': 'Une erreur technique est survenue.',
  '95': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '96': 'Une erreur est apparue lors de la remise de cette transaction.',
  '97': 'Date de remise trop éloignée.',
  '98': 'Date de transaction invalide.',
  '99': 'Une erreur est survenue lors du calcul de l\'origine du paiement.',
  '100': 'Contrôle carte commerciale en échec.',
  '101': 'Refusé car première échéance refusée.',
  '102': 'L\'opération a été refusée par Buyster.',
  '103': 'Le statut de la transaction n\'a pas pu être synchronisé avec le système externe',
  '104': 'Une erreur est apparue lors de la remise de cette transaction.',
  '105': 'Une erreur de sécurité est apparue lors du processus 3DS de cette transaction.',
  '106': 'Devise non supportée pour ce contrat et/ou cette boutique.',
  '107': 'La carte associée à l\'alias n\'est plus valide.',
  '108': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '109': 'Délai d\'attente dépassé lors de la redirection de l\'acheteur.',
  '110': 'Carte de paiement non supportée par le contrat.',
  '111': 'Refus des transactions sans transfert de responsabilité.',
  '112': 'L\'annulation n\'est pas autorisée.',
  '113': 'La duplication n\'est pas autorisée.',
  '114': 'Le forçage n\'est pas autorisé.',
  '115': 'Le remboursement n\'est pas autorisé.',
  '116': 'Paiement manuel non autorisé pour cette carte.',
  '118': 'Paiement manuel en plusieurs fois non autorisé pour cette carte.',
  '119': 'La date soumise est invalide.',
  '120': 'L\'option de paiement de la transaction initiale n\'est pas applicable.',
  '124': 'Carte inactive.',
  '125': 'Paiement refusé par l\'acquéreur.',
  '126': 'Cette action n\'est pas possible car la séquence de paiement n\'est pas terminée.',
  '127': 'Le champ vads_ship_to_delay n\'est pas renseigné ou son format est invalide.',
  '132': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '135': 'L\'intégration de la page de paiement dans une iframe n\'est pas autorisée.',
  '136': 'Refus des transactions dérivées sans transfert de responsabilité sur la transaction primaire.',
  '137': 'La transaction est un doublon.',
  '138': 'Le remboursement partiel n\'est pas possible sur cette transaction.',
  '139': 'Remboursement refusé.',
  '141': 'L\'analyseur de risque a rejeté cette transaction.',
  '142': 'Le type de carte utilisé n\'est pas valide pour le mode de paiement demandé.',
  '143': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande.',
  '144': 'Une transaction en mode production a été marquée en mode test chez l\'acquéreur.',
  '145': 'Une transaction en mode test a été marquée en mode production chez l\'acquéreur.',
  '146': 'Code sms invalide.',
  '147': 'Le module de gestion de fraudes a demandé le refus de cette transaction.',
  '148': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande. La transaction n\'a pas été créée.',
  '149': 'La durée de la session de paiement a expiré (cas de l\'acheteur qui est redirigé vers l\'ACS et qui ne finalise pas l\'authentification 3D Secure).',
  '150': 'Suite à un incident technique nous ne sommes pas en mesure de traiter votre demande. La transaction n\'a pas été créée.',
  '205': '3D Secure interrompu sur erreur technique du Directory Server'
};
